var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGrid(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 495,
    height: 372,
    viewBox: "0 0 495 372",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_308_95)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.5 309.07H494.1",
    stroke: "#D3D3D3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.9 0.499512V370.79",
    stroke: "#D3D3D3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.5 185.639H494.1",
    stroke: "#D3D3D3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.301 0.499512V370.79",
    stroke: "#D3D3D3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.5 62.2095H494.1",
    stroke: "#D3D3D3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.699 0.499512V370.79",
    stroke: "#D3D3D3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.1992 0.499512V370.79",
    stroke: "#D3D3D3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.5 247.36H494.1",
    stroke: "#D3D3D3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.6 0.499512V370.79",
    stroke: "#D3D3D3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.5 123.929H494.1",
    stroke: "#D3D3D3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309 0.499512V370.79",
    stroke: "#D3D3D3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432.4 0.499512V370.79",
    stroke: "#D3D3D3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M484.1 0.499512H10.5C4.97715 0.499512 0.5 4.97666 0.5 10.4995V360.79C0.5 366.312 4.97715 370.79 10.5 370.79H484.1C489.623 370.79 494.1 366.312 494.1 360.79V10.4995C494.1 4.97666 489.623 0.499512 484.1 0.499512Z",
    stroke: "#D3D3D3"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_308_95"
  }, /*#__PURE__*/React.createElement("rect", {
    y: -0.000488281,
    width: 494.6,
    height: 371.29,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrid);
export default __webpack_public_path__ + "static/media/grid.99b1034067f865f474e5d27f79ca0a1a.svg";
export { ForwardRef as ReactComponent };